// Add these imports at the top if not already present
import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import styled from "styled-components";

// Add these styled components
const CustomDropdownContainer = styled.div`
  position: relative;
  width: 120px;
  margin-top: 10px;
  padding-top: 20px;
`;

const DropdownButton = styled.button`
  width: 100%;
  padding: 10px 16px;
  background: #1a2e2d;
  border: 2px solid #52b2cf;
  border-radius: 8px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s ease;

  &:hover {
    background: #234441;
    border-color: #7dcfeb;
  }

  svg {
    transition: transform 0.2s ease;
    transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0)")};
  }
`;

const DropdownList = styled.div`
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  width: 100%;
  background: #1a2e2d;
  border: 2px solid #52b2cf;
  border-radius: 8px;
  overflow: hidden;
  z-index: 1000;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};
  transform: ${(props) =>
    props.isOpen ? "translateY(0)" : "translateY(-10px)"};
  transition: all 0.2s ease;
`;

const DropdownItem = styled.div`
  padding: 10px 16px;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${(props) => (props.isSelected ? "#234441" : "transparent")};

  &:hover {
    background: #234441;
  }
`;

// Custom Dropdown Component
export const CustomLanguageDropdown = ({ onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const dropdownRef = useRef(null);

  const languages = [
    { value: "English", label: "English" },
    { value: "Hindi", label: "हिंदी" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language.label);
    setIsOpen(false);
    onChange({ target: { value: language.value } }); // Maintain compatibility with existing onChange
  };

  return (
    <CustomDropdownContainer ref={dropdownRef}>
      <DropdownButton onClick={() => setIsOpen(!isOpen)} isOpen={isOpen}>
        <span>{selectedLanguage}</span>
        <ChevronDown size={20} />
      </DropdownButton>

      <DropdownList isOpen={isOpen}>
        {languages.map((language) => (
          <DropdownItem
            key={language.value}
            isSelected={selectedLanguage === language.label}
            onClick={() => handleLanguageSelect(language)}
          >
            {language.label}
          </DropdownItem>
        ))}
      </DropdownList>
    </CustomDropdownContainer>
  );
};

// Replace your existing language dropdown with:
